jQuery( 'img.svg' ).each( function() {
  const $img = jQuery( this );
  const imgID = $img.attr( 'id' );
  const imgClass = $img.attr( 'class' );
  const imgURL = $img.attr( 'src' );

  jQuery.get( imgURL, function( data ) {
    let $svg = jQuery( data ).find( 'svg' );
    if ( typeof imgID !== 'undefined' ) {
      $svg = $svg.attr( 'id', imgID );
    }
    if ( typeof imgClass !== 'undefined' ) {
      $svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
    }
    $svg = $svg.removeAttr( 'xmlns:a' );
    if ( !$svg.attr( 'viewBox' ) && $svg.attr( 'height' ) && $svg.attr( 'width' ) ) {
      $svg.attr( 'viewBox', '0 0 ' + $svg.attr( 'height' ) + ' ' + $svg.attr( 'width' ) );
    }
    $img.replaceWith( $svg );
  }, 'xml' );
} );

jQuery( '.back-to-top' ).on( 'click', function() {
  jQuery( 'html, body' ).animate( { scrollTop: 0 }, 'fast' );
} );

jQuery(document).ready(function($) {
  $('.count-up .heading').each(function() {
      const $heading = $(this);
      const originalText = $heading.text();
      const numericValue = parseFloat(originalText.replace(/[^\d.-]/g, '')); // Extract numeric value

      if (!isNaN(numericValue)) {
          const decimalPlaces = (numericValue % 1 === 0) ? 0 : 1; // Determine decimal places
          const duration = 2000; // Animation duration in milliseconds

          let startTime = null;
          function updateValue(timestamp) {
              if (!startTime) startTime = timestamp;
              const elapsedTime = timestamp - startTime;

              if (elapsedTime <= duration) {
                  const progress = Math.min(1, elapsedTime / duration);
                  const easedProgress = easeInOutQuad(progress); // Use smoother easing function
                  const animatedValue = numericValue * easedProgress;
                  const newValue = originalText.replace(numericValue, animatedValue.toFixed(decimalPlaces));
                  $heading.text(newValue);
                  requestAnimationFrame(updateValue);
              } else {
                  $heading.text(originalText.replace(numericValue, numericValue.toFixed(decimalPlaces)));
              }
          }

          requestAnimationFrame(updateValue);
      }
  });
});

// Easing function: InOut Quadratic
function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}